import { FunctionComponent as F, useEffect, useState } from "react";
import MaUTable from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import { MmProtocol } from "../../core/http/mmProtocol";
import MmProtocolTableRow from "./MmProtocolTableRow";
import MmProtocolTableHeader from "./MmProtocolTableHeader";



interface IProps
{
  protocol: MmProtocol
}


const MmProtocolTable: F<IProps> = (props: IProps) =>
{
  const [rows, setRows] = useState(props.protocol?.dosings.map(d => ({ ...d, checked: false })));

  const headings = [
    { Header: 'Checked', accessor: 'checked' },
    { Header: 'Supplement', accessor: 'suppName' },
    { Header: 'Dose', accessor: 'dose' },
    { Header: '', accessor: 'doseUnit' },
    { Header: 'Doses per day', accessor: 'dosesPerDay' },
    { Header: 'Days per month', accessor: 'daysPerMonth' }];


  useEffect(() =>
  {
    setChecked(rows.every(row => row.checked));
  }, [rows]);

  const [checked, setChecked] = useState(false);

  const handleHeaderCheck = () =>
  {
    const newProtocol = rows.map(row => ({ ...row }));
    newProtocol.forEach(row => row.checked = !checked);

    setRows(newProtocol);
    setChecked(!checked);
  };

  const handleRowCheck = (mmProtocolDosingId: number) =>
  {
    const newProtocol = rows.map(row => ({ ...row }));
    newProtocol.forEach(row =>
    {
      if(row.mmProtocolDosingId !== mmProtocolDosingId)
        return;

      row.checked = !row.checked;
    });

    setRows(newProtocol);
  };

  return (
    <MaUTable key='MaUTable' size='small' sx={{ width: 600 }}>
      <MmProtocolTableHeader
        headings={headings}
        checked={rows.length ? checked : false}
        handleCheck={handleHeaderCheck}/>
      <TableBody>
        {rows.map((row, rowIndex) => <MmProtocolTableRow
          key={rowIndex}
          mmProtocolId={props.protocol.mmProtocolId}
          row={row}
          rowIndex={rowIndex}
          headers={headings}
          handleCheck={() => handleRowCheck(row.mmProtocolDosingId)}/>)}
      </TableBody>
    </MaUTable>);
};

export default MmProtocolTable;
